import { create } from "zustand";
import { ModeType } from "../components/CreateNewProject/NewProjectForm";
import { logger } from "./logger";
const initialState = {
    assetDetails: [],
    completedStep: 0,
    coordinates: [],
    modeType: ModeType.CREATE,
    projectAddress: "",
    projectAddressLat: "",
    projectAddressLng: "",
    projectId: "",
    projectName: "",
    projectOwner: "",
    projectStatus: ""
};
const useNewProjectStore = create()(logger((set, get) => ({
    ...initialState,
    getCompletedStep() {
        return get().completedStep;
    },
    getProjectId() {
        return get().projectId;
    },
    getProjectInfo: () => {
        return {
            coordinates: get().coordinates,
            modeType: get().modeType,
            projectAddress: get().projectAddress,
            projectAddressLat: get().projectAddressLat,
            projectAddressLng: get().projectAddressLng,
            projectId: get().projectId,
            projectName: get().projectName,
            projectOwner: get().projectOwner,
            projectStatus: get().projectStatus
        };
    },
    setAssetDetails: (assetDetails) => {
        set(() => ({ assetDetails }));
    },
    setCompletedStep: (completedStep) => {
        set(() => ({ completedStep }));
    },
    setCoordinates: (coordinates) => {
        set(() => ({ coordinates }));
    },
    setModeType: (modeType) => {
        set(() => ({ modeType }));
    },
    setProjectAddress: (projectAddress) => {
        set(() => ({ projectAddress }));
    },
    setProjectAddressLat: (projectAddressLat) => {
        set(() => ({ projectAddressLat }));
    },
    setProjectAddressLng: (projectAddressLng) => {
        set(() => ({ projectAddressLng }));
    },
    setProjectId: (projectId) => {
        set(() => ({ projectId }));
    },
    setProjectName: (projectName) => {
        set(() => ({ projectName }));
    },
    setProjectOwner: (projectOwner) => {
        set(() => ({ projectOwner }));
    },
    setProjectStatus: (projectStatus) => {
        set(() => ({ projectStatus }));
    },
    setReset: () => {
        set(() => ({
            assetDetails: [],
            completedStep: 0,
            coordinates: [],
            modeType: ModeType.CREATE,
            projectAddress: "",
            projectAddressLat: "",
            projectAddressLng: "",
            projectId: "",
            projectName: "",
            projectOwner: "",
            projectStatus: ""
        }));
    }
}), "NewProjectStore"));
export default useNewProjectStore;
